import { Space, Table } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import Page from "../../../Common/Page";
import { PaginationComponent } from "~Common/Pagination/PaginationComponent";
import SearchFilter from "~components/SearchFilter/SearchFilter";
import { useHandlePagination } from "~hooks/useHandlePagination";
import { useHttp } from "~hooks/useHttp";
import { getColumns } from "./columnsRepository";
import useFetchEntity from "~pages/Roster/hooks/useFetchEntity";

const TableToolbar = styled.div`
  display: flex;
  justify-content: end;
  align-content: center;
`;

const RosterImages = () => {
  const { formatMessage } = useIntl();
  const [searchText, setSearchText] = useState("");
  const [refreshFlag, setRefreshFlag] = useState(true);
  const [paginationString, setPaginationString] = useState("limit=1000&offset=0");
  const [filteredData, setFilteredData] = useState([]);
  const { sport, organizationId, seasonId, entityId, customerId } = useParams();

  const { data: entity, isLoading: isEntityLoading } = useFetchEntity(entityId);

  const { request, loading, error } = useHttp();
  const [data, setData] = useState();
  const loadData = useCallback(() => {
    request({
      url: `/v1/${sport}/o/${organizationId}/seasons/${seasonId}/entities/${entityId}/roster?include=organizations,entities,seasons,persons&${paginationString}`,
    })
      .then((data) => {
        setData(data);
      })
      .catch((e) => {
        console.error("error loading venues", e);
      });
  }, [request, paginationString, sport, organizationId, seasonId, entityId]);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (refreshFlag) {
      loadData();
      setRefreshFlag(false);
    }
  }, [refreshFlag]);

  useEffect(() => {
    if (data) {
      let filteredData = data !== null ? data.data : [];

      filteredData.forEach((result, index) => {
        filteredData[index] = {
          ...result,
          ...data.includes?.resources?.persons?.[result.person?.id],
        };
        filteredData[index].status = result.status;
      });

      if (searchText !== "") {
        filteredData = filteredData.filter((result) => {
          return result.nameFullLocal.toUpperCase().indexOf(searchText.toUpperCase()) > -1;
        });
      }

      setFilteredData(filteredData);
      setRefreshFlag(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchText]);

  const { pageSize, currentPage, handlePaginationChange } = useHandlePagination();

  const title = `${entity?.nameFullLocal || entity?.entityId} ${formatMessage({ id: "roster.images" })}`

  return (
    <React.Fragment>
      <Page
        title={title}
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          <TableToolbar>
            <SearchFilter doSearch={setSearchText} />
          </TableToolbar>
          <Table
            loading={loading}
            columns={getColumns({
              formatMessage,
              customerId: customerId,
              sport: sport,
            })}
            dataSource={filteredData}
            size="small"
            pagination={{
              current: currentPage,
              defaultPageSize: pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              position: ["bottomCenter"],
              total: filteredData?.length || 0,
              onChange: handlePaginationChange,
              showTotal: (total, range) => <PaginationComponent pageSize={pageSize} total={total} range={range} />,
            }}
            rowKey={(x) => x.personId}
          />
        </Space>
      </Page>
    </React.Fragment>
  );
};

export default RosterImages;
